export const CurrentVenueFragment = /* GraphQL */ `
	fragment CurrentVenueFragment on Venue {
		_id
		created_at
		updated_at
		name
		description
		address
		timezone
		logo
		banner_img
		is_self_served
		allow_comments
		item_types
		cancelled_reason_options
		custom_payment_types {
			label
			value
			is_deactivated
		}
		shifts {
			title
			startTime
			endTime
		}
		auto_print_checklist
		currencies_configs {
			code
			rate
			previous_rate
			is_primary_currency
			is_secondary_currency
			is_deactivated
		}
		fcm_tokens
		is_service_charge_buried
		service_charge
		service_charge_bd
		default_service_charge_type
		is_service_charge_bd_buried
		is_vat_buried
		vat
		theme {
			primary_color
			primary_text_color
		}
		is_ordering_requires_customer
		is_qr_ordering_only
		custom_note_instructions
		is_ordering_requires_note
		is_ordering_requires_staff_accept
		order_notification_dings
		ops_page_font_size
		is_payway_integration_enabled
		is_internal_receipt_enabled
		is_language_localization_enabled
		is_digital_menu_user_login_enabled
		is_digital_menu_user_sign_up_enabled
		is_digital_menu_additional_language_enabled
		additional_digital_menu_languages
		user_limit
		is_required_headcount_before_payment
		is_payment_confirmation_enabled
		is_accounting_journal_enabled
		is_room_master_integration_enabled
		room_master_property_id
		custom_printing_fields {
			label
		}
		vat_tin
		preset_messages
		is_inventory_management_enabled
		inventory_start_date
		is_reservation_management_enabled
		is_customer_management_enabled
		is_kds_enabled
		is_custom_report_enabled
		is_cost_management_enabled
		is_payment_rounding_enabled
		allow_add_items_to_paid_orders
		available_printers {
			name
		}
		stations {
			_id
			printer_name
			station_name
			types_of_interest
			locations_of_interest
			printer_tags_of_interest
			is_cashdrawer_enabled
			is_group_printer_tags_on_one_ticket
		}
		print_content_padding
		print_font_sizes {
			ticket
			receipt
			reports
		}
		operational_data_refetch_interval
		is_print_ticket_by_item
		is_print_ticket_by_option
		is_grouping_option_on_print_ticket
		is_work_ticket_remove_order_number
		is_work_ticket_remove_price
		is_include_total_qty_in_receipt
		reports_display_figure
		default_ops_page
		is_till_send_and_pay_enabled
		is_till_send_enabled
		is_location_lock_enabled
		is_kpay_integration_enabled
		card_surcharge
		tax
		is_ordering_requires_headcount
		bill_footer
		is_wallet_management_enabled
		wallet_payment_labels
		should_clear_location_after_payment
		is_reports_enabled
		reports_availability_windows {
			title
			startTime
			endTime
		}
		is_offline_mode_enabled
		only_one_order_per_location
		receipt_config {
			prefix
			suffix_digit
			current_date
			current_number
			current_date_internal
			current_number_internal
			type
		}
		is_offers_crud_for_super_admin_only
		is_cloudbeds_integration_enabled
		cloudbeds_integration_info {
			property_id
		}
		is_item_tags_enabled
		is_report_tags_enabled
	}
`;
